// @ts-nocheck
import { getCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import useGetSetting from "@insite/client-framework/Common/Hooks/useGetSetting";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import Drawer, { DrawerPresentationProps } from "@insite/mobius/Drawer";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import X from "@insite/mobius/Icons/X";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { useEffect, useState } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { typographyInvertColorStyles } from "@store/Themes/common/mixins/typography";
import breakpoint from "@store/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@store/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
/* Starter Custom Code - End */

export interface CookiePrivacyPolicyPopupStyles {
    drawer?: DrawerPresentationProps;
    container?: GridContainerProps;
    messageGridItem?: GridItemProps;
    messageText?: TypographyPresentationProps;
    acceptGridItem?: GridItemProps;
    acceptButton?: ButtonPresentationProps;
    closeGridItem?: GridItemProps;
    closeButton?: ButtonPresentationProps;
    // Starter Custom Code
    actionWrapper?: InjectableCss;
    closeLink?: LinkPresentationProps;
}

export const cookiePrivacyPolicyPopupStyles: CookiePrivacyPolicyPopupStyles = {
    drawer: {
        position: "bottom",
        cssOverrides: {
            scrim: css`
                height: auto;
            `,
            drawerBody: css`
                position: relative;
                height: auto;
            `,
            drawerTitle: css`
                display: none;
            `,
            drawerContent: css`
                ${typographyInvertColorStyles()}
                display: flex;
                align-items: flex-start;
                background-color: ${getColor("primary.dark")}; /* Store Custom Code */
                min-height: ${pxToRem(100)};
                ${breakpointValues([pxToRem(20), null, pxToRem(20, 30), null, pxToRem(25, 45)], "padding")}
                ${breakpointValues([pxToRem(15, 25), null, pxToRem(15, 30)], "gap")}

                ${breakpoint("md")} {
                    flex-direction: row;
                    align-items: center;
                }
            `,
        },
        closeButtonProps: {
            css: css`
                display: none;
            `,
        },
        enableClickThrough: true,
    },
    messageText: {
        variant: "p",
        css: css`
            overflow-x: hidden;
            overflow-y: visible;
            max-height: 50vh;
            flex-grow: 1;
            margin: 0;
        `,
    },
    actionWrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            flex-shrink: 0;
            gap: inherit;
        `,
    },
    acceptButton: {
        variant: "inverted" as any,
    },
};

const styles = cookiePrivacyPolicyPopupStyles;

const CookiePrivacyPolicyPopup = () => {
    const location = useAppSelector(o => getLocation(o));
    const enableCookiePrivacyPolicyPopup = useGetSetting(o => o.websiteSettings.enableCookiePrivacyPolicyPopup);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (enableCookiePrivacyPolicyPopup && !getCookie("acceptCookies")) {
            setIsOpen(true);
        }
    }, [location.pathname]);

    const acceptHandler = () => {
        setIsOpen(false);
        setCookie("acceptCookies", "true", { expires: 365 });
    };

    const closeHandler = () => {
        setIsOpen(false);
    };

    return (
        <Drawer isOpen={isOpen} {...styles.drawer} data-test-selector="drawer_CookiePolicy">
            {/* Starter Custom Code - Start */}
            <Typography {...styles.messageText} data-test-selector="cookiePolicy_PrivacyPolicy">
                {siteMessage("Core_CookiePrivacyPolicy")}
            </Typography>
            <StyledWrapper {...styles.actionWrapper}>
                <Button
                    {...styles.acceptButton}
                    onClick={acceptHandler}
                    data-test-selector="cookiePolicy_AcceptCookies"
                >
                    {siteMessage("Core_CookiePrivacyPolicyAccept")}
                </Button>
                <Link {...styles.closeLink} onClick={closeHandler} data-test-selector="cookiePolicy_ClosePolicy">
                    {translate("Close")}
                </Link>
            </StyledWrapper>
            {/* Starter Custom Code - End */}
        </Drawer>
    );
};

export default CookiePrivacyPolicyPopup;
